<div class="content-wrapper-inner">
  <div *ngIf="loading" class="full-page-spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <form [formGroup]="form" *ngIf="form" class="pos-relative form">
    <div *ngFor="let pane of layout" class="settings-container mb-20" [ngClass]="pane.className">
      <h3 class="mb-20">{{ pane.title }}</h3>
      <div class="row">
        <div *ngFor="let column of pane.columns" [ngClass]="column.className">
          <div *ngFor="let control of column.controls" class="control" [ngClass]="control.className">
            <div class="form-group">
              <label class="form-label">{{ control.label }}</label>
              <input [formControlName]="control.id" class="form-control" (input)="onChangeSetting(settingsMap[control.id], form.controls[control.id])" />
            </div>
            <div class="form-control-errors"><input-errors [control]="form.controls[control.id]" [service]="validationService"></input-errors></div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="table-action-info-bar" *ngIf="changesCount > 0" style="padding: 0">
  <div class="info-right">
    <button class="btn btn-primary" (click)="onClickSave()" [disabled]="!form || !form.valid"><i class="far fa-save"></i> Save ({{ changesCount }})</button>
  </div>
</div>



<ng-template #saveModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Are you sure?</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <table class="table">
      <tbody>
        <ng-container *ngFor="let p of getChangesSettings()">
          <tr>
            <td colspan="2" class="text-center">{{ p.title }}</td>
          </tr>
          <tr *ngFor="let c of p.controls">
            <td>{{ c.label }}</td>
            <td class="text-right"><code>{{ c.parsed.value }}</code> to <code>{{ c.parsed.newValue }}</code></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="modal-footer pt-15 d-flex justify-content-between align-items-center">
    <a role="button" class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</a>
    <button class="btn btn-primary" type="submit" (click)="dialogRef.close(true)">Yes</button>
  </div>
</ng-template>
